var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8.99994,
    r: 6,
    stroke: "#1a1a1a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6464 16.3535C15.8417 16.5488 16.1583 16.5488 16.3536 16.3535C16.5488 16.1582 16.5488 15.8416 16.3536 15.6464L15.6464 16.3535ZM12.6464 13.3535L15.6464 16.3535L16.3536 15.6464L13.3536 12.6464L12.6464 13.3535Z",
    fill: "#1a1a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/searchWhite.f75feb520be24dc65dc919c7104a6aeb.svg";
export { ForwardRef as ReactComponent };